import React from 'react';
import { spacer12 } from '@spotify-internal/encore-foundation';
import styled from 'styled-components';
import IconX from "../Icon/IconX";
var Button = styled.button.attrs(function (props) {
  return {
    'aria-label': 'Close',
    onClick: props.onClose
  };
}).withConfig({
  displayName: "CloseButton__Button",
  componentId: "gu3wox-0"
})(["background-color:transparent;border:1px solid transparent;margin:-1px;color:inherit;line-height:0;padding:0;position:absolute;right:", ";top:", ";&:focus{border-color:currentColor;border-style:dotted;outline:none;}"], spacer12, spacer12);
export default function CloseButton(props) {
  return React.createElement(Button, props, React.createElement(IconX, {
    "aria-hidden": "true"
  }));
}